import { render, staticRenderFns } from "./XmNewMultipleChoice.vue?vue&type=template&id=55f9f656&scoped=true"
import script from "./XmNewMultipleChoice.vue?vue&type=script&lang=js"
export * from "./XmNewMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./XmNewMultipleChoice.vue?vue&type=style&index=0&id=55f9f656&prod&lang=scss&scoped=true"
import style1 from "./XmNewMultipleChoice.vue?vue&type=style&index=1&id=55f9f656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9f656",
  null
  
)

export default component.exports